import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * ScrollToTop component that scrolls the window to the top whenever
 * the pathname in the location (URL) changes.
 */
export function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Scroll to the top of the page when the pathname changes
    window.scrollTo(0, 0)
  }, [pathname])

  // This component doesn't render anything, it just performs an effect
  return null
} 